<template>
  <div
    class="search-page-search-bar-dropdown-component"
    v-if="showDropdownResults"
  >
    <SearchPageSearchBarDropdownResult
      class="searchbar-dropdown-item"
      :pageName="pageName"
      v-for="dropdownItem in dataDropdown"
      :key="dropdownItem.id"
      :result="dropdownItem"
    />
  </div>
  <div
    class="search-page-search-bar-dropdown-component"
    v-if="!showDropdownResults && searchPageStore.searchPageState.search.focus"
  >
    <nav>
      <div class="searchbar-dropdown-item-title">Recently Viewed</div>
      <SearchPageSearchBarDropdownResult
        class="searchbar-dropdown-item"
        :pageName="pageName"
        v-for="dropdownItem in recentlyViewedItems"
        :key="dropdownItem.id"
        :result="dropdownItem"
      />
    </nav>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useSearchPageStore } from "@/store/store/searchPageStore";
import SearchPageSearchBarDropdownResult from "@/components/v2/search-page/SearchPageSearchBarDropdownResult.vue";

const searchPageStore = useSearchPageStore();

const props = defineProps({
  pageName: {
    type: String,
    default: "",
  },
});

const dataDropdown = computed(
  () => searchPageStore.searchPageState.dataDropdown
);

const recentlyViewedItems = computed(
  () => searchPageStore.searchPageState.recentlyViewed
);

const showDropdownResults = computed<boolean>(
  () =>
    searchPageStore.searchPageState.search.typing &&
    searchPageStore.searchPageState.search.typing.length >= 3 &&
    searchPageStore.searchPageState.search.focus
);

const showRecentlyViewedResults = computed<boolean>(
  () =>
    (searchPageStore.searchPageState.search.typing &&
      searchPageStore.searchPageState.search.typing.length < 3 &&
      searchPageStore.searchPageState.search.focus) ||
    (!searchPageStore.searchPageState.search.typing &&
      searchPageStore.searchPageState.search.focus)
);

onMounted(() => {
  searchPageStore.getRecentlyViewedPages();
});
</script>

<style scoped>
div.xpage-searchbar-dropdown {
  z-index: 999;
  position: absolute;
  left: 0;
  width: 350px;
  background-color: white;
  box-shadow: 0 0 6px #0000003d;
  margin-top: 1px;
}

div.search-page-search-bar-dropdown-component {
  z-index: 9999999;
  position: absolute;
  width: 454px;
  background-color: white;
  box-shadow: 0 0 6px #0000003d;
  margin-top: 1px;
}
div.search-page-search-bar-dropdown-component > a {
  background: white;
}

.searchbar-dropdown-item {
  background-color: white;
  border-bottom: 1px solid #eeeeee;
  margin-top: 1px;
  cursor: pointer;
}

.searchbar-dropdown-item:hover {
  background: #eeeeee;
}

.searchbar-dropdown-item-title {
  text-transform: uppercase;
  font-size: 11px;
  margin-top: 20px;
  margin-bottom: 10px;
  padding-left: 15px;
  font-weight: 700;
}
</style>
